// @core/api/endpoints/platform/create_platform_invitation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreatePlatformInvitationRequest,
  PlatformInvitationResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Invite user to platform
 * Sends an invitation to join the platform to the specified email address. The invitation includes the role that will be assigned upon acceptance.
 */
export async function CreatePlatformInvitation(
  platform_id: string,
  data: CreatePlatformInvitationRequest,
  options?: RequestOptions
): Promise<PlatformInvitationResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/invitations`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.post<PlatformInvitationResponse>(requestPath, data, requestOptions);
}
